import * as d3 from "d3";
import * as Plot from "@observablehq/plot";

import "./charts.scss";

declare global {
  interface Window {
    d3: typeof d3;
    Plot: typeof Plot;
  }
}

window.d3 = d3;
window.Plot = Plot;

const charts = document.querySelectorAll("[data-chart-id]");

charts.forEach((element) => {
  const id = element.getAttribute("data-chart-id");

  if (!id) {
    console.error("Missing chart id");
    return;
  }

  if (id.startsWith("/") || id.endsWith("/")) {
    console.error(`Invalid chart id: ${id}`);
    return;
  }

  const script = document.createElement("script");
  script.src = `https://cdn.down-syndrome.org/assets/${id}/chart.min.js`;
  script.type = "module";
  document.body.appendChild(script);
});
